module.exports = __webpack_public_path__ + "img/microplastics-process-3-mobile.2a03d073.png";